import React, { useRef, useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import axios from "../../api/axiosInstance"; // import your axios instance
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const categories = [
  "E.G. LEARNING ESSENTIALS",
  "CLASSES",
  "EXPERIENCE",
  "GEARS",
  "GROWING UP",
  "GENERAL",
  "TOYS"
];

export default function CreateFund() {
    const navigate = useNavigate();
  const fileInputRef = useRef();
    const [kids, setKids] = useState([]); 

      
const [form, setForm] = useState({
  cash_fund_name: "",
  description: "",
  amount: "",
  category: "",
  imgUrl: "",
  child_id: "", // ✅ Add this field
  no_maximum_amount_restricted: false,
  end_cash_fund_on_event_date: false,
});

  const [imgPreview, setImgPreview] = useState(null);


const fetchProfile = async () => {
    try {
      const response = await axios.get("/v1/profile/getBuddyProfile");
      if (response.data.status !== "success") {
        throw new Error("Failed to fetch profile data");
      }
      setKids(response.data.data.profile.children || []); // Set children from profile
   
    } catch (error) {
      console.error(error);
    }
  };

  // Handle field changes
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value
    }));
  };


   useEffect(() => {
      fetchProfile();
    }, []);


  // Image upload (simulate uploading and getting a URL, or use actual upload endpoint)
  const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const formData = new FormData();
    formData.append("image", file);

    const res = await axios.post("/v1/image/uploadCashFundPicture", formData);

    if (res.data && res.data.data && res.data.data.key) {
      setImgPreview(res.data.data.signedUrl); // For preview
      setForm(prev => ({
        ...prev,
        imgUrl: res.data.data.key // Store key/S3 path for backend
      }));
      toast.success("Cash fund image updated!");
    } else {
      toast.error("Upload failed. Try again!");
    }
  } catch (error) {
    console.error("Cash fund image upload error:", error);
    toast.error("Cash fund image upload failed!");
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const selectedChild = kids.find((child) => child.id === Number(form.child_id));
    if (!selectedChild) {
      return toast.error("Selected child not found.");
    }

    const body = {
      ...form,
      amount: Number(form.amount),
      child_id: selectedChild.id,
      child_first_name: selectedChild.first_name,
      child_last_name: selectedChild.last_name || "",
      child_age: selectedChild.age || null, // Backend compatible
    };

    const res = await axios.post("/v1/cashfund/create-cash-fund", body);
    toast.success("Your Cash Fund has been created successfully!");
    navigate("/dashboard/home");
  } catch (err) {
    toast.error("Error creating fund: " + (err.response?.data?.message || err.message));
  }
};


  return (
    <>
      <Navbar />
      <div style={{
        background: "#fff",
        minHeight: "100vh",
        fontFamily: "Nunito, sans-serif",
        padding: "32px"
      }}>
        <h1 style={{
          letterSpacing: "0.29em",
          fontWeight: 700,
          fontSize: "2rem",
          margin: "0 0 40px 0"
        }}>CREATE FUND</h1>
        <div style={{
          maxWidth: "900px",
          margin: "0 auto",
          border: "2px solid #FFDD94",
          borderRadius: "24px",
          padding: "36px",
          position: "relative"
        }}>
          <form onSubmit={handleSubmit}>
            <label htmlFor="fundName" style={{
              fontWeight: 700,
              letterSpacing: "0.2em",
              fontSize: "1rem"
            }}>
              BUDDY FUND NAME:
            </label>
            <input
              id="fundName"
              name="cash_fund_name"
              value={form.cash_fund_name}
              onChange={handleChange}
              type="text"
              style={{
                width: "100%",
                margin: "8px 0 24px 0",
                padding: "12px",
                borderRadius: "6px",
                border: "1.5px solid #FFDD94",
                fontSize: "1rem",
                fontFamily: "inherit"
              }}
              required
            />

             {/* Child Selector Dropdown */}
            <label htmlFor="childId" style={{
              fontWeight: 700,
              letterSpacing: "0.2em",
              fontSize: "1rem"
            }}>
              CHILDS NAME
            </label>
            <select
              id="childId"
              name="child_id"
              value={form.child_id}
              onChange={handleChange}
              style={{
                width: "100%",
                margin: "8px 0 24px 0",
                padding: "12px",
                borderRadius: "6px",
                border: "1.5px solid #FFDD94",
                fontSize: "1rem",
                fontFamily: "inherit"
              }}
              required
            >
              <option value="" disabled>Select a child</option>
              {kids.map((child) => (
                <option value={child.id} key={child.id}>
                  {child.first_name} {child.last_name ? child.last_name : ""}
                </option>
              ))}
            </select>


            <label htmlFor="description" style={{
              fontWeight: 700,
              letterSpacing: "0.2em",
              fontSize: "1rem"
            }}>
              DESCRIPTION
            </label>
            <textarea
              id="description"
              name="description"
              value={form.description}
              onChange={handleChange}
              rows={2}
              placeholder="Max has been dreaming of a bike for the past year. We’d love your help making this wish come true! 600 words max"
              style={{
                width: "100%",
                margin: "8px 0 24px 0",
                padding: "12px",
                borderRadius: "6px",
                border: "1.5px solid #FFDD94",
                fontSize: "1rem",
                fontFamily: "inherit",
                resize: "none"
              }}
            />

            <div style={{ display: "flex", gap: "36px", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <label htmlFor="amount" style={{
                  fontWeight: 700,
                  letterSpacing: "0.17em",
                  fontSize: "1rem"
                }}>
                  AMOUNT
                </label>
                <input
                  id="amount"
                  name="amount"
                  value={form.amount}
                  onChange={handleChange}
                  type="number"
                  style={{
                    display: "block",
                    width: "70%",
                    margin: "8px 0 16px 0",
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1.5px solid #FFDD94",
                    fontSize: "1rem",
                    fontFamily: "inherit"
                  }}
                  required
                />
                <div
                  onClick={() => fileInputRef.current.click()}
                  style={{
                    border: "1.5px dashed #B5B5B5",
                    borderRadius: "8px",
                    height: "90px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "18px 0 8px 0",
                    background: "#fafafa",
                    cursor: "pointer",
                    width: "98%"
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <div style={{ textAlign: "center", color: "#B5B5B5" }}>
                    {imgPreview ? (
                      <img src={imgPreview} alt="preview" style={{ height: 100, marginBottom: 6 }} />
                    ) : (
                      <img
                        alt="upload"
                        src="https://img.icons8.com/ios-filled/50/000000/upload.png"
                        style={{ width: 40, height: 40, marginBottom: 6 }}
                      />
                    )}
                    <br />
                    <span style={{
                      fontSize: "0.98rem",
                      letterSpacing: "0.1em"
                    }}>
                      CLICK OR DRAG FILE TO UPLOAD
                    </span>
                  </div>
                </div>
                <div>
                  <label style={{ fontWeight: 400, fontSize: "0.96em" }}>
                    <input
                      type="checkbox"
                      name="no_maximum_amount_restricted"
                      checked={form.no_maximum_amount_restricted}
                      onChange={handleChange}
                      style={{ marginRight: 8 }}
                    />
                    NO MAXIMUM AMOUNT RESTRICTED
                  </label>
                  <br />
                  <label style={{ fontWeight: 400, fontSize: "0.96em" }}>
                    <input
                      type="checkbox"
                      name="end_cash_fund_on_event_date"
                      checked={form.end_cash_fund_on_event_date}
                      onChange={handleChange}
                      style={{ marginRight: 8 }}
                    />
                    END CASH FUND ON EVENT DATE
                  </label>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <label htmlFor="category" style={{
                  fontWeight: 700,
                  letterSpacing: "0.17em",
                  fontSize: "1rem"
                }}>
                  CATEGORY
                </label>
                <select
                  id="category"
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    margin: "8px 0 22px 0",
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1.5px solid #FFDD94",
                    fontSize: "1rem",
                    fontFamily: "inherit"
                  }}
                  required
                >
                  <option value="" disabled>
                    E.G. LEARNING ESSENTIALS
                  </option>
                  {categories.slice(1).map((cat) => (
                    <option value={cat} key={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <button
              type="submit"
              style={{
                position: "absolute",
                bottom: 24,
                right: 36,
                border: "2px solid #FFDD94",
                borderRadius: "50%",
                background: "#fff",
                width: 48,
                height: 48,
                fontSize: "2.1rem",
                color: "#FFDD94",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              title="Add Fund"
            >
              +
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
